import React from "react";

interface EmailInitialProps {
  email?: string | null;
  className?: string;
}

const EmailInitial: React.FC<EmailInitialProps> = ({ email, className = "" }) => {
  const getInitial = () => {
    if (!email) return "U";
    return email.charAt(0).toUpperCase();
  };

  return (
    <p className={`bg-content2 p-2 text-xl rounded-xl w-12 h-12 text-center ${className}`}>
      {getInitial()}
    </p>
  );
};

export default EmailInitial;